class Top {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {

    gsap.utils.toArray(".js-img-parallax").forEach((img) => {
      gsap.to(img, {
        y: (i, target) => target.clientHeight * -0.2, // パララックスの効果量を調整（-0.2など）
        ease: "none",
        scrollTrigger: {
          trigger: img,
          start: "top bottom", // 表示領域に入るタイミング
          end: "bottom top",   // 表示終了領域を設定
          scrub: 1,         // スクロールに応じてアニメーションが同期
        },
      });
    });

    // カウントアップの関数
    function countUp(element) {
      const target = $(element);
      const countTo = parseFloat(target.data('count')); // data-countの値を取得
      let startVal = countTo % 1 === 0 ? 1 : 0.1; // 小数点があれば0.1から開始、なければ1から開始
      const increment = startVal;

      $({ countNum: startVal }).animate(
        { countNum: countTo },
        {
          duration: 1333, // カウントアップの時間を2/3に設定
          easing: 'swing',
          step: function () {
            target.text(this.countNum.toFixed(countTo % 1 === 0 ? 0 : 1));
          },
          complete: function () {
            target.text(countTo.toFixed(countTo % 1 === 0 ? 0 : 1));
          },
        }
      );
    }

    // 表示領域に入ったときにカウントアップする処理
    $(window).on('scroll', function () {
      $('.js-countup').each(function () {
        const elemPos = $(this).offset().top;
        const scroll = $(window).scrollTop();
        const windowHeight = $(window).height();

        if (scroll > elemPos - windowHeight && !$(this).hasClass('counted')) {
          $(this).addClass('counted'); // 重複カウントを防止
          countUp(this); // カウントアップの実行
        }
      });
    });

    // Swiperのインスタンスを宣言するための変数
    let parallaxSlider;

    // Swiperが使用する要素が存在するか確認
    if ($('.image-slider').length > 0) {
      parallaxSlider = new Swiper('.image-slider', {
        loop: true,
        effect: 'fade',
        allowTouchMove: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        speed: 2000,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      });
    }

    // parallaxSliderのインスタンスが存在する場合のみ自動再生を停止
    if (parallaxSlider) {
      parallaxSlider.autoplay.stop();
    }

    var tl = gsap.timeline();

    tl.to(".js-h1 div span", .8, {
      y: 0,
      stagger: 0.2,
    }, '0.5');
    tl.to(".js-img", 1, {
      y: 0,
      opacity: 1,
      force3D: true,
    }, '-=0.5');
    tl.to(".js-slider", 1, {
      y: 0,
      opacity: 1,
      force3D: true,
    }, '-=0.5');
    tl.to(".js-mascot", 0.5, {
      x: 0,
      opacity: 1,
    }, '+=0.5');
    tl.to(".js-header", 1, {
      opacity: 1,
      force3D: true,
      onComplete: () => {
        if (parallaxSlider) {
          parallaxSlider.autoplay.start();
        }
      },
    }, '<');

    let companySlider = {
      loop: true,
      effect: 'fade',
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 1500,
    };

    $('.company-slider').each(function(index) {
      new Swiper(`.company-slider${index + 1}`, companySlider);
    });

    let irSwiper;
    irSwiper = new Swiper('.irSwiper', {
      spaceBetween: 20,
      slidesPerView: 1.2,
      speed: 500,
      breakpoints: {
        // スライドの表示枚数：767px以上の場合
        767: {
          spaceBetween: 30,
          slidesPerView: 3.6,
        }
      },
      navigation: {
        nextEl: ".irSwiper-prev",
        prevEl: ".irSwiper-next",
      },
    });

    // JSONデータを取得し、スライドを生成する関数
    async function fetchDataAndCreateSlides() {
      try {
        // URLからJSONデータをフェッチ
        const response = await fetch('https://science-arts.com/buddycomNewsJson.php');
        
        // JSONデータをパース
        const jsonData = await response.json();
        
        // スライドを挿入する要素を取得
        const container = await document.querySelector('#news');

        // JSONデータから8件を取得してスライドを作成
        await jsonData.slice(0, 8).forEach((item) => {
          const slide = document.createElement('div');
          slide.classList.add('swiper-slide');

          const anchor = document.createElement('a');
          anchor.href = item.link;
          anchor.target = '_blank';

          const dl = document.createElement('dl');

          const dt = document.createElement('dt');
          const date = document.createElement('span');
          date.classList.add('date');
          date.textContent = item.date; // 日付を適宜変更

          const label = document.createElement('span');
          label.classList.add('label', 'label-info');
          label.textContent = 'News release';

          dt.appendChild(date);
          dt.appendChild(label);

          const dd = document.createElement('dd');
          const p = document.createElement('p');
          p.classList.add('ttl');
          p.textContent = item.title;

          dd.appendChild(p);

          dl.appendChild(dt);
          dl.appendChild(dd);

          anchor.appendChild(dl);
          slide.appendChild(anchor);
          container.appendChild(slide);
        });

        let newsSwiper;
        newsSwiper = new Swiper('.newsSwiper', {
          spaceBetween: 20,
          slidesPerView: 1.2,
          speed: 500,
          breakpoints: {
            // スライドの表示枚数：767px以上の場合
            767: {
              spaceBetween: 30,
              slidesPerView: 3.6,
            }
          },
          navigation: {
            nextEl: ".irSwiper-prev",
            prevEl: ".irSwiper-next",
          },
        });

      } catch (error) {
        console.error('データの取得に失敗しました', error);
      }
    }

    // ページロード時にデータを取得してスライドを生成
    fetchDataAndCreateSlides();


  }
}
